import React, { FC, useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';

interface SearchInputProps {
  label: string;
  value: string;
  onSearch: (value: string) => void;
  delay?: number;
}

const SearchInput: FC<SearchInputProps> = ({
  label,
  value,
  onSearch,
  delay = 300,
}) => {
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  useEffect(() => {
    const handler = window.setTimeout(() => {
      onSearch(inputValue);
    }, delay);

    return () => {
      window.clearTimeout(handler);
    };
  }, [inputValue, delay, onSearch]);

  return (
    <TextField
      fullWidth
      label={label} 
      size="small"
      value={inputValue}
      onChange={(event) => {
        setInputValue(event.target.value);
      }}
    />
  );
};

export default SearchInput;
